export default __webpack_public_path__ + "static/team-Loic-bb5b02a39ebca08e7c65000793959838.png";